import { render } from "./OutlaysCategories.vue?vue&type=template&id=49b6a5e3"
import script from "./OutlaysCategories.vue?vue&type=script&lang=js"
export * from "./OutlaysCategories.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__